import { createRouter, createWebHistory } from 'vue-router'
import ProfileEnum from '@/enum/profileEnum'
import store from '../store'
import PATHS from './routesMap'

import Auth from '../views/auth/Auth.vue'

const routes = [
  {
    name: 'Auth',
    path: PATHS.AUTH,
    component: Auth,
  },
  {
    name: 'PasswordRecovery',
    path: PATHS.PASSWORD_RECOVERY,
    component: () =>
      import(
        /* webpackChunkName: "passwordRecovery" */ '../views/auth/PasswordRecovery.vue'
      ),
  },
  {
    name: 'NewPassword',
    path: PATHS.NEW_PASSWORD,
    component: () =>
      import(
        /* webpackChunkName: "newPassword" */ '../views/auth/NewPassword.vue'
      ),
  },
  {
    name: 'Home',
    path: PATHS.HOME,
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'AdminUsers',
    path: PATHS.ADMIN_USERS,
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/users/Users.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    name: 'RegistriesBidders',
    path: PATHS.REGISTRIES_BIDDERS,
    component: () =>
      import(
        /* webpackChunkName: "registries" */ '../views/registries/bidders/Bidders.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RegistriesBiddersDetails',
    path: PATHS.REGISTRIES_BIDDERS_DETAILS,
    component: () =>
      import(
        /* webpackChunkName: "registries" */ '../views/registries/bidders/BidderDetails.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RegistriesPartners',
    path: PATHS.REGISTRIES_PARTNERS,
    component: () =>
      import(
        /* webpackChunkName: "admin" */ '../views/registries/partners/Partners.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RegistriesPartnersDetails',
    path: PATHS.REGISTRIES_PARTNERS_DETAILS,
    component: () =>
      import(
        /* webpackChunkName: "admin" */ '../views/registries/partners/PartnerDetails.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Projects',
    path: PATHS.PROJECTS,
    component: () =>
      import(
        /* webpackChunkName: "projects" */ '../views/projects/Projects.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ProjectsDetails',
    path: PATHS.PROJECTS_DETAILS,
    component: () =>
      import(
        /* webpackChunkName: "projects" */ '../views/projects/ProjectDetails.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Unauthorized',
    path: PATHS.UNAUTHORIZED,
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from) => {
  const { isLoggedSGPIn, getProfileById } = store.getters

  if (isLoggedSGPIn && to.name === 'Auth') {
    return { name: 'Home' }
  }
  if (to.meta.requiresAuth) {
    if (!isLoggedSGPIn && !localStorage.getItem('tokenSGP')) {
      return { name: 'Auth' }
    }
    if (to.meta.requiresAdmin && !getProfileById(ProfileEnum.ADMINISTRADOR)) {
      return { name: 'Unauthorized' }
    }
  }
})

router.afterEach(async (to, from) => {
  if (!store.getters.isLoggedSGPIn && to.meta.requiresAuth) {
    await store.dispatch('logout')
    router.push(PATHS.AUTH)
  }
})

export default router
